export const getGraphFilterMapping = (filter, timeRange) => {
	const metricMap = {
		'Customers Onboarded': 'total_customers_registered',
		'Active Consents': 'total_active_consents',
		'Pending Consent Requests': 'total_pending_consents',
		'Revoked Consents': 'total_revoked_consents',
		'Rejected Consents': 'total_rejected_consents',
		'Failed Data Requests': 'total_failed_data_request',
		'Successful Data Requests': 'total_successful_data_request',
		'Active Subscriptions': 'active_subscriptions',
		'Inactive Subscriptions': 'inactive_subscriptions',
		'Currently Linked Accounts': 'currently_linked_accounts',
		'Total Accounts': 'total_accounts',
	};
	const metricName = metricMap[filter];
	// console.log(metricName);
	let appendedTimeInterval = '';
	if (timeRange === 'YEARLY') appendedTimeInterval = '_1y';
	else if (timeRange === 'MONTHLY') appendedTimeInterval = '_1m';
	else if (timeRange === 'DAILY') appendedTimeInterval = '_1d';
	return metricName + appendedTimeInterval;
};

export const horizontalAxisMapping = (timeRange, pair) => {
	let name;
	if (timeRange === 'DAILY') name = pair.key.split('-')[2];
	else if (timeRange === 'MONTHLY') {
		let monthNum = pair.key.split('-')[1];
		const monthMapping = {
			'01': 'Jan',
			'02': 'Feb',
			'03': 'Mar',
			'04': 'Apr',
			'05': 'May',
			'06': 'Jun',
			'07': 'Jul',
			'08': 'Aug',
			'09': 'Sep',
			10: 'Oct',
			11: 'Nov',
			12: 'Dec',
		};
		name = monthMapping[monthNum];
	} else if (timeRange === 'YEARLY') name = pair.key.split('-')[0];
	return name;
};
